import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { forkJoin, of, Subscription } from 'rxjs';
import { catchError, finalize, take } from 'rxjs/operators';

import { HeaderComponent } from '../header/header.component';
import { FooterComponent } from '../footer/footer.component';
import { PricingModalComponent } from '../../../shared/components/pricing-modal/pricing-modal.component';
import { PricingService } from '../../services/pricing/pricing.service';
import { WalletService } from '../../services/wallet/wallet.service';
import { BuyCreditsService } from '../../services/pricing/buy-credits.service';
import { PricingMeter } from '../../models/pricing/pricing.model';
import { WalletInfo } from '../../models/wallet/wallet.model';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [CommonModule, RouterOutlet, HeaderComponent, FooterComponent, PricingModalComponent],
  templateUrl: './layout.component.html'
})
export class LayoutComponent implements OnInit, OnDestroy {
  showPricingModal = false
  isPreparingPricingModal = false
  prefetchedMeters: PricingMeter[] | null = null
  prefetchedWallet: WalletInfo | null = null
  private buyCreditsSub?: Subscription

  constructor(
    private pricingService: PricingService,
    private walletService: WalletService,
    private buyCreditsService: BuyCreditsService
  ) {}

  ngOnInit(): void {
    this.buyCreditsSub = this.buyCreditsService.openRequests$.subscribe(() => this.openPricingModal())
  }

  ngOnDestroy(): void {
    this.buyCreditsSub?.unsubscribe()
  }

  openPricingModal(): void {
    if (this.isPreparingPricingModal) {
      return
    }

    this.isPreparingPricingModal = true
    forkJoin({
      meters: this.pricingService.listPricingMeters().pipe(catchError(() => of([] as PricingMeter[]))),
      wallet: this.walletService.getWallet().pipe(catchError(() => of(null)))
    })
      .pipe(
        take(1),
        finalize(() => (this.isPreparingPricingModal = false))
      )
      .subscribe(({ meters, wallet }) => {
        this.prefetchedMeters = meters
        this.prefetchedWallet = wallet
        this.showPricingModal = true
      })
  }

  closePricingModal(): void {
    this.showPricingModal = false
    this.prefetchedMeters = null
    this.prefetchedWallet = null
  }
}
